import styled from 'styled-components';

import { typography, spacing } from '../../../../styles/theme';

export const Container = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 80px 0;
`;

export const Header = styled.header`
  width: 64%;
`;

export const Title = styled.h1`
  font-size: ${typography('heading4.fontSize')};
  margin-bottom: ${spacing('2')};
`;
